import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Flex, Header } from "@/eworkitComponents";
import { EmailMessage, IWithEmailResendProps, withEmailResend } from "@/views/Session/components/EmailMessage";

const EmailSentComponent: FunctionComponent<IWithEmailResendProps> = props => {
  const { t } = useTranslation("public");

  return (
    <EmailMessage {...props}>
      <Flex direction="column" innerMargin="md" align="center">
        <Header size="sm" align="center">
          {t("SESSION_LOGIN.EMAIL_REQUIRED.HEADER_LINE1")}
        </Header>
        <Header size="sm" align="center">
          {t("SESSION_LOGIN.EMAIL_REQUIRED.HEADER_LINE2")}
        </Header>
      </Flex>
    </EmailMessage>
  );
};

export const EmailRequired = withEmailResend(EmailSentComponent);
